import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
	selector: 'app-filter-chips-bar',
	standalone: true,
	templateUrl: './app-filter-chips-bar.component.html',
	styleUrls: ['./app-filter-chips-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFilterChipsBarComponent {
	title = input<string | null>(null);
	helper = input<string | null>(null);
	dense = input(false);
}
